import React from "react";

// "Sign in with Plot OS" — the central-login entry point (guide §9).
// REACT_APP_* are inlined at BUILD time; when unset the button doesn't render,
// so the SSO entry point is a clean no-op until the env is configured.
const LOGIN_URL = process.env.REACT_APP_PLOT_OS_LOGIN_URL;
const SLUG = process.env.REACT_APP_PLOT_OS_SLUG;

const PlotOsButton = () => {
  if (!LOGIN_URL || !SLUG) return null;
  const href = `${LOGIN_URL.replace(/\/+$/, "")}/?slug=${encodeURIComponent(SLUG)}`;
  return (
    <>
      <div className="d-flex align-items-center my-2">
        <hr className="flex-grow-1 m-0" />
        <span className="px-2 text-muted ft-8">or</span>
        <hr className="flex-grow-1 m-0" />
      </div>
      <a href={href} className="btn btn-outline-success m-0 w-100" role="button">
        <i className="bi bi-box-arrow-in-right me-1"></i>
        Sign in with Plot OS
      </a>
    </>
  );
};

export default PlotOsButton;
